import * as PropTypes from "prop-types";
import styled from "styled-components";

export default function CloseButton({ id, onClick, children }) {
  return (
    <ButtonStyled id={id} onClick={onClick} type="button">
      {children}
    </ButtonStyled>
  );
}

const ButtonStyled = styled.button`
  background-color: transparent;
  color: #747474;
  font-size: 20px;
  outline: none;
  padding: 0;

  &:first-child {
    padding-left: 0;
  }

  &:hover {
    color: #2a2a2a;
    cursor: pointer;
    transition: color 0.2s;
  }
`;

CloseButton.propTypes = {
  children: PropTypes.any,
  onClick: PropTypes.func.isRequired,
  id: PropTypes.string,
};

CloseButton.defaultProps = {
  id: "",
};
